import mitt from 'mitt';

type Events = {
  openMessagesModal: { messageID: number } | undefined;
};

export const eventBus = mitt<Events>();